<!-- <div style=" display: flex;left:300px; bottom: 30px;position: absolute;"> -->

<div>

  <button class="ml-2"   (click)="setSpeed()"   mat-icon-button>
    <fa-icon  style="font-size:12px;"   icon="forward" ></fa-icon>
  </button>

  <button class="ml-2" color="primary" [disabled]="!mapComp.pausePlaying" mat-icon-button   (click)="mapComp.pausePlaying = false">
    <fa-icon style="font-size:12px;"   icon="play-circle"></fa-icon>
  </button>
  <button class="ml-2" color="accent" [disabled]="mapComp.pausePlaying" mat-icon-button   (click)="mapComp.pausePlaying = true">
    <fa-icon style="font-size:12px;"   [icon]="['fas','pause-circle']"></fa-icon>
  </button>
  <button class="ml-2 mr-2" mat-icon-button color="warn"   [disabled]="!mapComp.isPlaying" (click)="mapComp.cancelPlaying = true; mapComp.repeatPlaying=false">
    <fa-icon style="font-size:12px;"   icon="stop-circle"></fa-icon>
  </button>
  <button class="ml-2 mr-2" mat-icon-button *ngIf="!mapComp.cancelPlaying" (click)="mapComp.repeatPlaying = !mapComp.repeatPlaying">
    <fa-icon style="font-size:12px;"  [ngStyle]="mapComp.repeatPlaying ? {'backgroundColor': 'green'} : ''"  icon="repeat"></fa-icon>
  </button>
  <span class="mr-2" style="font-weight: bold">{{mapComp.playingSpeedX}}X</span>
</div>
  <div class="ml-2" style="display: block;width: 260px; margin-top: 7px; color: #f2f2f2;" *ngIf="mapComp.currentPlayingTransform">
     {{mapComp.currentPlayingTransform}}
  </div>
<!--- </div> -->
